import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { Icon } from '@/components/ui/icon';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const Buttons = ({ align, buttons }) => {
  let alignmentClass = 'justify-center';
  if (align === 'left') {
    alignmentClass = 'justify-start';
  } else if (align === 'right') {
    alignmentClass = 'justify-end';
  }

  return (
    <div className={`mt-6 mb-6 flex flex-wrap ${alignmentClass} gap-2`}>
      {buttons.map((button, index) => (
        <VisibleLoading key={button.id} delay={(index + 1) * 200}>
          {({ ref, className }) => (
            <Button
              ref={ref}
              variant={button.variant}
              size={button.size}
              asChild={true}
              className={`basis-full xl:basis-auto ${className || ''}`.trim()}
            >
              <Link href={button.url || ''}>
                <Icon type={button.icon} /> {button.label}
              </Link>
            </Button>
          )}
        </VisibleLoading>
      ))}
    </div>
  );
};
export default Buttons;
